const NEEDS_RESEARCH_KEY = 'nyris-api-key-needs-research';

export function markNeedsResearchAfterApiKey(): void {
  try {
    sessionStorage.setItem(NEEDS_RESEARCH_KEY, '1');
  } catch {
    // ignore
  }
}

export function consumeNeedsResearchAfterApiKey(): boolean {
  try {
    const value = sessionStorage.getItem(NEEDS_RESEARCH_KEY);
    if (value) {
      sessionStorage.removeItem(NEEDS_RESEARCH_KEY);
      return true;
    }
  } catch {
    // ignore
  }
  return false;
}

export function peekNeedsResearchAfterApiKey(): boolean {
  try {
    return sessionStorage.getItem(NEEDS_RESEARCH_KEY) === '1';
  } catch {
    return false;
  }
}

const ALLOWED_RETURN_PATHS = new Set(['/', '/result', '/api-key']);

export function sanitizeReturnTo(path: unknown): string {
  if (typeof path !== 'string') return '/';
  if (!path.startsWith('/') || path.startsWith('//')) return '/';
  const pathname = path.split('?')[0]?.split('#')[0] || '/';
  if (ALLOWED_RETURN_PATHS.has(pathname)) return pathname;
  return '/';
}
